export interface News {
  objectID: string;
  title: string;
  subTitle: string;
  schedulingDate: Date | string;
  startDate: Date;
  endDate: Date;
  status: NewsStatusEnum;
  dedicatedPage: boolean;
  externalUrl: string;
  image?: string;
  banner?: string;
  description?: string;
}

export enum NewsStatusEnum {
  Draft = 'draft',
  Archived = 'archived',
  Online = 'online',
}
